import { create } from 'zustand';

// Holds the short-lived signupToken between /auth/otp/verify (SIGNUP_REQUIRED)
// and /auth/signup/complete. In-memory only — not persisted. The signup
// "intent" (client vs associate) is no longer kept here; it travels on the URL
// (`/otp?as=associate`) which removes the cross-navigation timing issues we
// hit when it lived in the store.
type SignupState = {
  signupToken: string | null;
  email: string | null;
  set: (v: { signupToken: string; email: string }) => void;
  clear: () => void;
};

export const useSignupStore = create<SignupState>((set) => ({
  signupToken: null,
  email: null,
  set: ({ signupToken, email }) => set({ signupToken, email }),
  clear: () => set({ signupToken: null, email: null }),
}));
